import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Customers.scss';
import messages from '../messages';
import bmb from './bmb.jpg';
import bitmedia from './bitmedia.jpg';
import fcio from './fcio.jpg';
import talentify from './talentify.jpg';
import tu from './tu.png';
import mavoco from './mavoco.jpg';
import ak from './arbeiterkammer.jpg';

const testimonialMessages = defineMessages({
  student: {
    id: 'testimonials.student',
    defaultMessage: '{name}, Student from Vienna',
    description: 'Label for student testimonial',
  },
  teacher: {
    id: 'testimonials.teacher',
    defaultMessage: '{name}, Teacher from Vienna',
    description: 'Label for teacher testimonial',
  },
  student1: {
    id: 'testimonials.student1',
    defaultMessage: 'The app is great and very informative.',
    description: 'Student testimonial on home page',
  },
  student2: {
    id: 'testimonials.student2',
    defaultMessage: `
      The app is pretty cool. Could change chemistry lessons
      once and for all.
    `,
    description: 'Student testimonial on home page',
  },
  teacher1: {
    id: 'testimonials.teacher1',
    defaultMessage: `
      Binding structures and their changes can be
      explained more clearly than anywhere else.
    `,
    description: 'Teacher testimonial on home page',
  },
});

const testimonials = [
  {
    key: 1,
    user: (
      <FormattedMessage
        {...testimonialMessages.student}
        values={{ name: 'Lisa' }}
      />
    ),
    testimonial: <FormattedMessage {...testimonialMessages.student1} />,
  },
  {
    key: 2,
    user: (
      <FormattedMessage
        {...testimonialMessages.student}
        values={{ name: 'David' }}
      />
    ),
    testimonial: <FormattedMessage {...testimonialMessages.student2} />,
  },
  {
    key: 3,
    user: (
      <FormattedMessage
        {...testimonialMessages.teacher}
        values={{ name: 'Wolfgang' }}
      />
    ),
    testimonial: <FormattedMessage {...testimonialMessages.teacher1} />,
  },
];

/* eslint-disable prettier/prettier */
const partners = [
  { name: 'FCIO', logo: fcio, link: 'http://www.fcio.at/Default.aspx?site=fcio.at-DE' },
  { name: 'Bitmedia', logo: bitmedia, link: 'https://www.bitmedia.at/en/' },
  { name: 'Bundesministerium für Bildung', logo: bmb, link: 'https://www.bmb.gv.at/' },
  { name: 'talentify', logo: talentify, link: 'https://www.talentify.me/' },
  { name: 'Technical University of Vienna', logo: tu, link: 'https://www.tuwien.ac.at/en/' },
  { name: 'Mavoco', logo: mavoco, link: 'http://www.mavoco.com/' },
  { name: 'AK', logo: ak, link: 'https://wien.arbeiterkammer.at/beratung/bildung/schule/AK-App_Jopsy.html' },
];
/* eslint-enable prettier/prettier */

class Customers extends React.Component {
  render() {
    return (
      <div>
        <div className={s.container}>
          <h3>
            <FormattedMessage {...messages.ourUsersSay} />
          </h3>
          <div className={`${s.testimonials} row`}>
            {testimonials.map((testimonial, index) =>
              <div
                key={testimonial.key}
                className={`
                  ${s.testimonial}
                  ${index % 2 !== 0 ? s.testimonialInverse : null}
                  col-sm-4 col-xs-12
                `}
              >
                <div>
                  <p>
                    {testimonial.testimonial}
                  </p>
                  <span>
                    {testimonial.user}
                  </span>
                </div>
              </div>,
            )}
          </div>
        </div>
        <div className={s.partners}>
          <h3>
            <FormattedMessage {...messages.ourPartners} />
          </h3>
          {partners.map(partner =>
            <a
              key={partner.name}
              href={partner.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={partner.logo} alt={partner.name} />
            </a>,
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Customers);



// WEBPACK FOOTER //
// ./src/routes/home/customers/Customers.js